(function () {
  const WORKER_URL = 'https://bis.jewellerybox.co.uk';
const wrapper = document.getElementById('bis-form');
  if (!wrapper) return;
  if (wrapper.dataset.bisInit) return;
  wrapper.dataset.bisInit = '1';

const productId = wrapper.dataset.productId;
  const locale = wrapper.dataset.locale || '';
  const form = document.getElementById('bis-form-el');
  const variantInput = form.querySelector('[name="variant_id"]');
  const emailInput = form.querySelector('[name="email"]');
  const consentInput = form.querySelector('[name="consent"]');
  const consentWrapper = form.querySelector('.bis__consent');
  const hpInput = form.querySelector('[name="hp_field"]');
  const msg = form.querySelector('.bis__message');
  const submitBtn = form.querySelector('button[type="submit"]');
  const formShownAt = Date.now();

  const t = {
    submitting: wrapper.dataset.msgSubmitting,
    success: wrapper.dataset.msgSuccess,
    rateLimit: wrapper.dataset.msgRateLimit,
    error: wrapper.dataset.msgError,
  };

  function findAtc() {
    return document.querySelector(
      'product-form button[name="add"], form[action*="/cart/add"] button[name="add"], button[name="add"], .product-form__submit'
    );
  }

  function findPersonalisationOpener() {
    return document.querySelector('.personalise-opener');
  }

  function applyState(available, variantId) {
    const atc = findAtc();
    const personalise = findPersonalisationOpener();
    if (available) {
      wrapper.hidden = true;
      if (atc) { atc.disabled = false; atc.removeAttribute('aria-disabled'); atc.style.opacity = ''; }
      if (personalise) personalise.hidden = false;
    } else {
      wrapper.hidden = false;
      if (variantId) variantInput.value = variantId;
      if (atc) { atc.disabled = true; atc.setAttribute('aria-disabled', 'true'); atc.style.opacity = '0.5'; }
      if (personalise) personalise.hidden = true;
    }
  }

  applyState(wrapper.dataset.available === 'true', wrapper.dataset.variantId);

  document.addEventListener('variant:change', (e) => {
    const v = e.detail?.variant;
    if (v) applyState(v.available, v.id);
  });

  let lastVariantId = wrapper.dataset.variantId;
  async function syncFromUrl() {
    const id = new URLSearchParams(location.search).get('variant');
    if (!id || id === lastVariantId) return;
    lastVariantId = id;
    try {
      const product = await fetch(`${location.pathname}.js`).then(r => r.json());
      const v = product.variants.find(vv => String(vv.id) === id);
      if (v) applyState(v.available, v.id);
    } catch {}
  }
  setInterval(syncFromUrl, 750);

  consentInput.addEventListener('change', () => {
    if (consentInput.checked) consentWrapper.classList.remove('bis__consent--invalid');
  });

  form.addEventListener('submit', async (e) => {
    e.preventDefault();
    if (submitBtn.disabled) return;
    if (hpInput.value) return;
    if (Date.now() - formShownAt < 1500) return;

    consentWrapper.classList.remove('bis__consent--invalid');

    if (!emailInput.value) {
      emailInput.focus();
      return;
    }
    if (!consentInput.checked) {
      consentWrapper.classList.add('bis__consent--invalid');
      return;
    }

    submitBtn.disabled = true;
    msg.textContent = t.submitting;

    try {
      const res = await fetch(WORKER_URL, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          email: emailInput.value,
          variant_id: `gid://shopify/ProductVariant/${variantInput.value}`,
          product_id: `gid://shopify/Product/${productId}`,
          consent: consentInput.checked,
          locale: locale,
          honeypot: hpInput.value,
        }),
      });
      const data = await res.json();
      if (data.ok) {
        msg.textContent = t.success;
        form.reset();
      } else if (res.status === 429) {
        msg.textContent = t.rateLimit;
        submitBtn.disabled = false;
      } else {
        msg.textContent = t.error;
        submitBtn.disabled = false;
      }
    } catch {
      msg.textContent = t.error;
      submitBtn.disabled = false;
    }
  });
})();